import { useEffect } from "react";
import { AlertTriangle, CheckCircle, XCircle } from "lucide-react";

const AlertModal = ({ isOpen, onClose, message, type = "info" }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("no-scroll");
    }

    return () => {
      setTimeout(() => {
        const anyModalOpen = document.querySelector(".modal-open");
        if (!anyModalOpen) {
          document.body.classList.remove("no-scroll");
        }
      }, 100);
    };
  }, [isOpen]);

  if (!isOpen) return null;

  // Choose icon based on alert type
  const renderIcon = () => {
    switch (type) {
      case "success":
        return <CheckCircle className="text-green-500" size={64} />;
      case "error":
        return <XCircle className="text-red-500" size={64} />;
      case "info":
      default:
        return <AlertTriangle className="text-yellow-500" size={40} />;
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex justify-center items-center z-[1001] px-4 modal-open">
      <div className="bg-white rounded-xl shadow-2xl p-6 w-full max-w-md text-center">
        <div className="flex justify-center mb-4">
          {renderIcon()}
        </div>
        <p className="text-gray-800 mb-6 text-base">{message}</p>
        <button
          onClick={onClose}
          className="px-6 py-2 bg-blue-600 text-white rounded-full hover:bg-blue-700 text-sm"
        >
          OK
        </button>
      </div>
    </div>
  );
};

export default AlertModal;
